import { Container, Row, Col } from 'react-bootstrap';
import Cell from './cell';
import './style.css';
import CalendarEvent from './calendarEvent';
import { useState, useEffect } from 'react';
import ApiService from '../../services/ApiService';
import { add, differenceInDays, endOfMonth, format, setDate, startOfMonth, sub } from 'date-fns';
import Icon from '@mdi/react';
import { Link, useHistory } from 'react-router-dom';
import {
    mdiArrowRightBold,
    mdiArrowLeftBold,
    mdiChevronTripleUp,
    mdiChevronTripleDown,
} from '@mdi/js';
import { API_URL } from '../../config';
import { pl } from 'date-fns/locale';
import axios from 'axios';
const weeks = ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Ndz'];

type Props = {
    user: Object,
    value?: Date,
    filter?: boolean,
    onChange: (date: Date) => void,
    setHeader: any,
    localization: String,
    isInside?:boolean,
    changeModal:(date: Date) => void,
};



const Calendar = ({ value = new Date(), onChange, filter = false, setHeader,user,localization ,isInside = false, changeModal}: Props) => {
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const startDate = startOfMonth(value);
    const endDate = endOfMonth(value);
    const numDays = differenceInDays(endDate, startDate) + 1;
    const getSubaccountsURL = `${API_URL}GetSubaccounts`;
    const prefixDays = startDate.getDay() - 1;
    const suffixDays = 6 - endDate.getDay();
    const [getResponse, setGetResponse] = useState(0);
    const [userData, setUserData] = useState();
    const [response, setResponse] = useState([]);
    const [responseSub, setResponseSub] = useState([]);
    const [currentDayEvents, setCurrentDayEvents] = useState([]);
    const [bodyExpanded, setBodyExpanded] = useState(true);
    const [chooseUSerID, setChooseUSerID] = useState()

    const apiService = ApiService.getInstance();

    const prevMonth = () => onChange(sub(value, { months: 1 }));

    const nextMonth = () => onChange(add(value, { months: 1 }));

    const prevYear = () => onChange(sub(value, { years: 1 }));
    const nextYear = () => onChange(add(value, { years: 1 }));
    const history = useHistory();

    function tegetRelationsUsersst() {
       
        
        axios
            .get(getSubaccountsURL, config)
            .then((response) => {
                let list = [user]
                list = list.concat(response.data)
                
                setResponseSub(list);
                setGetResponse(response.data.length);
              
     
            })
            .catch(function (error) {
               
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
    
                }
            });}

    const handleClickDate = (index: number) => {
        const date = setDate(value, index);

        let arr = [];
        response.forEach((data) => {
            let x = new Date(Date.parse(data.eventDate));
            if (x.getDate() === date.getDate()) arr.push(data);
        });
        setCurrentDayEvents(arr);
    };

    const hideDetails = () => {
        var el = document.querySelector('.calendar__body');
        var el2 = document.querySelector('.calendar__events');
        if (el.hidden) {
            el.hidden = false;
            el2.hidden = false;
            setBodyExpanded(false);
        } else {
            el.hidden = true;
            el2.hidden = true;
            
            setBodyExpanded(true);
        }
    };

    const padTo2Digits = (num) => {
        return String(num).padStart(2, '0');
    };

    const capitalizeFirstLowercaseRest = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const getData = () => {
        let mDate = value;

        let lastDay = new Date(value.getFullYear(), value.getMonth() + 1, 0);
    
        mDate.setDate(1);

        
                
              
                const payload = {
                    eventDateFrom: mDate
                        .toISOString()
                        .substring(0, mDate.toISOString().indexOf('T')),
                    eventDateTo: `${lastDay.getFullYear()}-${padTo2Digits(
                        lastDay.getMonth() + 1
                    )}-${lastDay.getDate()}`,
                    current_LocalizationsID: 0,
                    keyController: 'usersSchedules',
                    usersID: chooseUSerID!=undefined?chooseUSerID: user?.usersID,
                };

                apiService.apiPost('CalculateProductForUser', payload, (response) => {
                   
                   if(response.success){ 
                    let arr = response.data.responseBody.body.body;
                    if (filter) {
                        arr = arr.filter(
                            (classes) =>
                                classes.sheduleItemTypeDVID == 6 || classes.sheduleItemTypeDVID == 9
                        );
                    }
                    setResponse(arr);}
                });
            }
        
    function changeEvetUser(id){
        let mDate = value;
        setChooseUSerID(id)
        let lastDay = new Date(value.getFullYear(), value.getMonth() + 1, 0);
    
        mDate.setDate(1);

        
                
              
                const payload = {
                    eventDateFrom: mDate
                        .toISOString()
                        .substring(0, mDate.toISOString().indexOf('T')),
                    eventDateTo: `${lastDay.getFullYear()}-${padTo2Digits(
                        lastDay.getMonth() + 1
                    )}-${lastDay.getDate()}`,
                    current_LocalizationsID: 0,
                    keyController: 'usersSchedules',
                    usersID: id,
                };

                apiService.apiPost('CalculateProductForUser', payload, (response) => {
                    
                   if(response.success){ 
                    let arr = response.data.responseBody.body.body;
                    if (filter) {
                        arr = arr.filter(
                            (classes) =>
                                classes.sheduleItemTypeDVID == 6 || classes.sheduleItemTypeDVID == 9
                        );
                    }
                    setResponse(arr);
                    setCurrentDayEvents([])}
                });
    }   useEffect(() => {
        if(filter){
            setHeader('/  ODWOŁANE ZAJĘCIA');
        }else{
        setHeader('/  KALENDARZ');}
        tegetRelationsUsersst();
        getData();
        
    }, [localization]);

    useEffect(() => {
        
        getData();
        
    }, [value]);
    useEffect(() => {
      
       
        
        getData();      
    }, [user]);

 

    return (
        <div className={isInside?"":"dashboard__content"}>
            
            <main>
            {isInside?"":<div className="filter_eventList">
            <p  style={{ color: 'black' }}>Pokaż dla:</p>
            <select></select>
            <select className="select_filterEventList" onChange={(e)=>{changeEvetUser(e.target.value)}}>
                {responseSub.map((user)=>{
                   
                    return <option value={user?.usersID}>{user?.firstName +" "+ user?.lastName}</option>
                })}
             </select>
             
             </div>}
                <Container className="calendar__border">
                    <Container className="calendar__header">
                        <Row className="row__bootstrap-header">
                            <Col onClick={prevMonth}>
                                <Icon path={mdiArrowLeftBold} size={1.3} className="mdi__icon" />
                            </Col>
                            <Col>
                                <Row className="row__month">
                                    <Col className="col__nowrap">
                                        <b style={{ color: '#CC0033' }}>
                                            {capitalizeFirstLowercaseRest(
                                                format(value, 'LLLL yyyy', { locale: pl })
                                            )}
                                        </b>
                                    </Col>
                                    <Col onClick={hideDetails}>
                                        <Icon
                                            path={
                                                bodyExpanded
                                                    ? mdiChevronTripleDown
                                                    : mdiChevronTripleUp
                                            }
                                            size={1}
                                            className="mdi__icon"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col onClick={nextMonth}>
                                <Icon path={mdiArrowRightBold} size={1.3} className="mdi__icon" />
                            </Col>
                        </Row>
                    </Container>

                    <Container className="calendar__body">
                        <div className="row row__bootstrap seven-cols">
                            {weeks.map((week) => (
                                <Cell children={<b>{week}</b>}></Cell>
                            ))}
                            <Container className="calendar__separate-line"></Container>
                            {Array.from({ length: prefixDays }).map((_, index) => (
                                <Cell></Cell>
                            ))}
                            {Array.from({ length: numDays }).map((_, index) => {
                                const date = index + 1;
                                const isCurrentDate = date === value.getDate();
                                let hasEvent = false;

                                response?.forEach((data) => {
                                    let x = new Date(Date.parse(data.eventDate));
                                    
                                    if (x.getDate() === date) hasEvent = true;
                                });

                                return (
                                    isInside?<Cell
                                    children={date}
                                    hasEvent={hasEvent}
                                    onClick={() => changeModal(date)}
                                ></Cell>:<Cell
                                        children={date}
                                        hasEvent={hasEvent}
                                        onClick={() => handleClickDate(date)}
                                    ></Cell>
                                );
                            })}

                            {Array.from({ length: suffixDays }).map((_, index) => (
                                <Cell></Cell>
                            ))}
                        </div>
                    </Container>
                    <Container className="calendar__events">
                        {currentDayEvents.length !== 0 ? <b>Lista zdarzeń</b> : <div></div>}
                        {currentDayEvents.length !== 0 ? (
                            <Container className="event__list">
                                {currentDayEvents.map((data) => (
                                    <CalendarEvent subAcont={responseSub} data={data} user={user}></CalendarEvent>
                                ))}
                            </Container>
                        ) : (
                            <div></div>
                        )}
                    </Container>
                </Container>
            </main>
        </div>
    );
};

export default Calendar;
